import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import heart from "../../Assets/Projects/heart.jpeg";
import music from "../../Assets/Projects/music.jpeg";
import resturant from "../../Assets/Projects/resturant.jpeg";
import adventure from "../../Assets/Projects/adventure.jpeg";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={resturant}
              isBlog={false}
              title="Resturant Rating Analysis "
              description="It is a project where real consumers from Mexico in year 2012, including additional information about each restaurant and their cuisines, and each consumer and their preferences are visualized through Power BI dashboard."
              ghLink="https://github.com/shivani0126/Resturant_Rating_Analysis"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={adventure}
              isBlog={false}
              title="Adventure Works Data Analysis"
              description="The objective of this project is to perform data analysis of Bicycle Manufacturing Company , to create an end-to-end sales analytic report based on Adventure Works database."
              ghLink="https://github.com/shivani0126/Adventure_Works_Data_Analysis"
              //demoLink="https://blogs.soumya-jit.tech/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={music}
              isBlog={false}
              title="Music Store Analysis"
              description="This project uses SQL to analyze the dataset of an online music store. The goal of the project is to answer a set of questions about the store’s business performance and help in its growth by making better decisions."
              ghLink="https://github.com/shivani0126/Music_Store_Analysis"
             // demoLink="https://editor.soumya-jit.tech/"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={heart}
              isBlog={false}
              title="Heart Health Prediction"
              description="The main goal is to identify which machine-learning algorithm has the best accuracy for the prediction of heart disease from the patient dataset."
              ghLink= "https://github.com/shivani0126/Heart_Health_Prediction"
              //demoLink="https://plant49-ai.herokuapp.com/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
